import { NarrativeConstants } from './narrative.constants'
import { INarrativeAction, INarrativeState } from './narrative.types'

export const initialNarrativeState: INarrativeState = {
  narrativeText: '',
  narrativeTextPNNV: null,
  hpi: '',
}

export function narrativeReducer(
  state: INarrativeState = initialNarrativeState,
  action: INarrativeAction
): INarrativeState {
  switch (action.type) {
    case NarrativeConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case NarrativeConstants.SET_NARRATIVE_TEXT:
      return { ...state, narrativeText: action.narrativeText }
    case NarrativeConstants.SET_NARRATIVE_TEXT_PNNV:
      return { ...state, narrativeTextPNNV: action.narrativeTextPNNV }
    case NarrativeConstants.SET_NARRATIVE_STATE:
      return { ...state, ...action.narrative }
    case NarrativeConstants.SET_HPI:
      return { ...state, hpi: action.hpi }
    case NarrativeConstants.RESET_STATE:
      return {
        narrativeText: '',
        narrativeTextPNNV: null,
        hpi: '',
      }
    default:
      return state
  }
}
